import React from 'react';
import { Link } from 'react-router-dom';

const PagoFallido = () => {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.iconError}>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </div>
        
        <h1 style={styles.title}>Pago no procesado</h1>
        <p style={styles.text}>
          Hubo un problema al procesar el pago con la plataforma. Tu pedido no fue completado y el stock fue liberado en la fábrica para resguardo del inventario.
        </p>
        <p style={styles.subtext}>
          Por favor, verificá los datos de tu tarjeta o saldo disponible e intentá la operación nuevamente.
        </p>

        <Link to="/Checkout" style={styles.btnPrimary}>
          Volver al Pago
        </Link>
      </div>
    </div>
  );
};

const styles = {
  container: { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '70vh', backgroundColor: '#f9fafb', padding: '20px' },
  card: { backgroundColor: '#ffffff', padding: '40px', borderRadius: '12px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)', textAlign: 'center', maxWidth: '500px', width: '100%' },
  iconSuccess: { width: '80px', height: '80px', backgroundColor: '#f0fdf4', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0 auto 24px' },
  iconError: { width: '80px', height: '80px', backgroundColor: '#fef2f2', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0 auto 24px' },
  iconPending: { width: '80px', height: '80px', backgroundColor: '#fef9c3', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0 auto 24px' },
  title: { fontSize: '24px', fontWeight: 'bold', color: '#111827', marginBottom: '16px', fontFamily: 'sans-serif' },
  text: { fontSize: '16px', color: '#4b5563', marginBottom: '12px', lineHeight: '1.5', fontFamily: 'sans-serif' },
  subtext: { fontSize: '15px', color: '#6b7280', marginBottom: '28px', lineHeight: '1.5', fontFamily: 'sans-serif' },
  link: { color: '#000000', fontWeight: 'bold', textDecoration: 'underline' },
  btnPrimary: { display: 'inline-block', backgroundColor: '#000000', color: '#ffffff', padding: '12px 24px', borderRadius: '8px', textDecoration: 'none', fontWeight: '600', fontSize: '15px', transition: 'background 0.2s' }
}; // Reutiliza el mismo objeto de estilos anterior
export default PagoFallido;